/**
 * The events layer, mounted once by the Shell: whichever events screen is
 * open (the list, an event, the editor), and the start notice (a toast
 * with Join for a channel event, View for one somewhere else).
 */
import { GuildScheduledEventEntityType as ET, type GuildScheduledEvent } from '@neosocial/protocol';
import { useEffect } from 'react';
import { joinVoiceFromUi } from '../hub/voiceUi';
import { tr } from '../i18n';
import { useFlag } from '../store/config';
import { toast } from '../ui/overlay';
import { EventEditor } from './EventEditor';
import { EventsDialog } from './EventsDialog';
import { setStartNotice } from './store';
import { openEvent, useEventsUi } from './ui';

export function showStartNotice(e: GuildScheduledEvent): void {
  const { t } = tr();
  const channel = e.entity_type !== ET.EXTERNAL ? e.channel_id : null;
  toast(t('ev.notice', { name: e.name }), {
    icon: 'calendar',
    tone: 'mode',
    duration: 12_000,
    action: channel
      ? { label: t('ev.join'), run: () => void joinVoiceFromUi(channel) }
      : { label: t('ev.notice.view'), run: () => openEvent(e.id) },
  });
}

export function EventsHost() {
  const on = useFlag('scheduled_events');
  const view = useEventsUi((s) => s.view);
  useEffect(() => {
    setStartNotice(showStartNotice);
    return () => setStartNotice(null);
  }, []);
  if (!on || !view) return null;
  if (view.kind === 'edit')
    return (
      <EventEditor
        key={view.id ?? 'new'}
        id={view.id}
        channelId={view.channelId}
        back={view.back}
      />
    );
  return <EventsDialog view={view} />;
}
